import { Chip } from '@mui/material';
import type { FacilityType } from '../../lib/facilities-api';
import { useT } from '../../i18n';

const COLORS: Record<FacilityType, 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning'> = {
  PADEL: 'primary',
  TENNIS: 'primary',
  BASKETBALL: 'warning',
  GYM: 'secondary',
  POOL: 'info',
  MEETING_ROOM: 'success',
  BBQ_AREA: 'warning',
  OTHER: 'default',
};

export const FACILITY_TYPE_KEY: Record<FacilityType, string> = {
  PADEL: 'fac.typePadel',
  TENNIS: 'fac.typeTennis',
  BASKETBALL: 'fac.typeBasketball',
  GYM: 'fac.typeGym',
  POOL: 'fac.typePool',
  MEETING_ROOM: 'fac.typeMeeting',
  BBQ_AREA: 'fac.typeBbq',
  OTHER: 'fac.typeOther',
};

export function FacilityTypeChip({ type }: { type: FacilityType }) {
  const t = useT();
  return <Chip label={t(FACILITY_TYPE_KEY[type] ?? type)} color={COLORS[type] ?? 'default'} size="small" />;
}
